import React from 'react';
import PropTypes from 'prop-types';
import {
  DtpButton,
  DtpButtonFlat,
  DtpButtonFab,
  DtpButtonFabMini,
  DtpSelectManyButton,
} from 'dtp-react-components';

const Button = (props) => {
  const pickButton = () => {
    if (props.icon) {
      if (props.mini) {
        return DtpButtonFabMini;
      }
      return DtpButtonFab;
    }
    if (props.flat) {
      return DtpButtonFlat;
    }
    if (props.many) {
      return DtpSelectManyButton;
    }
    return DtpButton;
  };

  const Component = pickButton();

  return (
    <Component
      {...props}
    />
  );
};

Button.defaultProps = {
  icon: null,
  mini: false,
  flat: false,
  many: false,
};

Button.propTypes = {
  icon: PropTypes.string,
  mini: PropTypes.bool,
  flat: PropTypes.bool,
  many: PropTypes.bool,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/Button.jsx